module.exports = __webpack_public_path__ + "static/media/region-script-copy.b4afa0a4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/region-script-copy.pdf
// module id = 189
// module chunks = 0